<form #formLogin="ngForm" name="formLogin" (submit)="handleLogin(formLogin.value, $event)" novalidate>
  <h3 class="text-dark-blue">{{ appCopy.panelHeader['title'+selectedLanguage] }}</h3>
  <p class="text-muted text-dark-blue">{{ appCopy.panelHeader['titleDescription'+selectedLanguage] }}</p>
  <div class="form-group">
    <input class="form-control" 
            [ngClass]="{ 'has-error' : username.invalid && username.dirty}"
            id="Username" 
            name="Username" 
            type="email" 
            #username="ngModel"
            [(ngModel)]="userEmail"
            [pattern]="emailPattern"
            ngModel 
            required
            appCheckEmpty>
    <label class="control-label" for="username"> {{ appCopy.panelHeader['emailPlaceholder'+selectedLanguage] }}</label>
    <i class="icon control-validation-state"></i>

    <p class="help-block text-danger" *ngIf="username?.errors?.pattern">{{ appCopy.panelHeader['validEmail'+selectedLanguage] }}</p>
    <p class="help-block text-danger" *ngIf="username.invalid && username.dirty && !username?.errors?.pattern">{{ appCopy.panelHeader['warningEmail'+selectedLanguage] }}</p>
  </div>

  <div class="form-group">
    <input class="form-control" 
            [ngClass]="{ 'has-error' : password.invalid && password.dirty }"
            id="Password"
            name="Password" 
            type="password"
            #password="ngModel"
            ngModel
            alert-caps-lock 
            required
            appCheckEmpty>
    <label class="control-label" for="Password">{{ appCopy.panelHeader['passwordPlaceholder'+selectedLanguage] }}</label>
    <i class="icon control-validation-state"></i>

    <p class="help-block text-danger" *ngIf="password.invalid && password.dirty">{{ appCopy.panelHeader['warningEnterPassword'+selectedLanguage] }}</p>
  </div>

  <div class="flex flex--space-between margin-bottom-16">
    <div class="checkbox checkbox--default checkbox--small">
      <input type="checkbox" name="rememberMe" id="rememberMe" #rememberme="ngModel" [(ngModel)]="rememberMe" [checked]="true">
      <label for="rememberMe text-dark-blue">{{ appCopy.panelHeader['rememberMe'+selectedLanguage] }}</label>
    </div>
    <a class="link" href="javascript:void(0)" *ngIf="parentRoute !== 'payment'" (click)="goToForgotPassword()">{{ appCopy.panelHeader['btnForgot'+selectedLanguage] }}</a>
  </div>

  <button type="submit" class="btn btn-purple btn-lg btn-block" [disabled]="formLogin.invalid">
    <div class="loader-container-btn" *ngIf="showLoader">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{ appCopy.panelHeader['btnLogin'+selectedLanguage] }}
  </button>
  <div class="hr-text text-center text-muted margin-top-32 margin-bottom-32" *ngIf="parentRoute !== 'passengers' && parentRoute !== 'payment'">
    <span>{{ appCopy.panelHeader['orText'+selectedLanguage] }}</span>
  </div>
  <button type="button" class="btn btn-primary btn-ghost btn-lg btn-block" *ngIf="parentRoute !== 'passengers' && parentRoute !== 'payment'" (click)="goToRegister()">
    {{ appCopy.panelHeader['btnCreate'+selectedLanguage] }}
  </button>
</form>